import { range } from 'lodash';

import {
  getFlexDates as _getFlexDates,
  formatServerDate,
} from '../../../../../utils/dateUtils';
import { getNightsRange as _getNightsRange } from '../../../../../utils/searchParamsUtils';

// TODO: LT-25099 нужно поменять изначальный тип поя startDate в сторе, по факту он string но задан как Date
export const getFlexDates = (
  startDate: Date | string,
  hasFlexDates: boolean,
): { from: Date | string; to: Date | string } => {
  if (!hasFlexDates) {
    return {
      from: startDate,
      to: startDate,
    };
  }

  const flexDates = _getFlexDates(new Date(startDate));
  const startDateFrom = formatServerDate(flexDates.from);
  const startDateTo = formatServerDate(flexDates.to);

  return {
    from: startDateFrom,
    to: startDateTo,
  };
};

export const getNightsRange = (
  nights: number,
  hasFlexNights: boolean,
): Array<number> => {
  if (!hasFlexNights) {
    return [nights];
  }

  const [nightsFrom, nightsTo] = _getNightsRange(nights);

  return range(nightsFrom, nightsTo + 1);
};
